<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card card-default">
                    <div class="card-header">Reset Password</div>

                    <div v-if="errors.length">
                        <b>Please correct the following error(s):</b>
                        <ul>
                            <li  class="alert alert-danger" v-for="error in errors">{{ error }}</li>
                        </ul>
                    </div>

                    <div v-if="show_success" class="alert alert-success" role="alert">
                        An email with password reset link is sent successfully.
                        <router-link tag="button" class="btn btn-primary" to="/sign_in">Sign In</router-link>
                    </div>
                    <div v-if="show_error" class="alert alert-danger" role="alert">
                        {{show_error}}

                    </div>
                    <div class="card-body">

                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">E-Mail Address</label>

                                <div class="col-md-6">
                                    <input id="email" type="email" class="form-control" v-model="email" required>
                                </div>
                            </div>


                            <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-4">
                                    <button type="submit" class="btn btn-primary" @click="handleSubmit">
                                        Email Password Reset Link
                                    </button>

                                </div>

                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "ForgotPasswordComponentOld",
        data(){
            return {
                email : "",
                errors: [],
                show_success: false,
                show_error: false,
            }
        },
        methods : {

            resetErrors() {
                this.errors = [];
            },
            resetStatusMessages() {
                this.show_success = this.show_error = false;
            },
            validate() {

               this.resetErrors();


                if(!this.validateEmailInput(this.email)) {
                    this.errors.push("Valid email required.");
                }

                return this.errors.length == 0;
            },

            handleSubmit(e) {
                this.resetErrors();
                this.resetStatusMessages();

                e.preventDefault();

                if (this.validate()) {

                    axios.post(this.apiEndPoints.forgotPassword, {
                        email: this.email,
                    })
                        .then(response => {
                            // console.log(response);

                            if(response.data && response.data.status) {

                                if(response.data.status == 'success') {
                                    this.show_success = true;
                                } else if(response.data.message) {
                                    this.show_error = response.data.message;
                                } else {
                                    this.show_error = response.data.message;
                                }
                            }
                        })
                        .catch(error => {
                            console.error(error.response);
                            this.show_error = true;
                            if(error.response.data.message) {
                                this.show_error = error.response.data.message;
                            } else {
                                this.show_error = 'An error occurred. Please try again!';
                            }

                        });
                }
            }
        }
    }
</script>

<style scoped>

</style>
